import firebase from 'firebase/app';
import "firebase/auth";
import "firebase/storage";
import "firebase/database";
import "firebase/functions";


const config = {
  apiKey: "AIzaSyA1SNv9RrhwqUtnx1wtOFN4bjxHV0xA4Po",
  authDomain: "holmangshage.firebaseapp.com",
  databaseURL: "https://holmangshage.firebaseio.com",
  projectId: "holmangshage",
  storageBucket: "holmangshage.appspot.com",
  messagingSenderId: "954396375228",
  appId: "1:954396375228:web:7fc6c1a5c72d7ddccc38b9",
  measurementId: "G-4JERVKPQ7V"
};

var fire = firebase.initializeApp(config);
export default fire;
